/**
 * File slider.js.
 *
 * Implement interactive mobile and desktop slider
 */

(function (root, factory) {
	if ( typeof define === 'function' && define.amd ) {
	  define([], factory(root));
	} else if ( typeof exports === 'object' ) {
	  module.exports = factory(root);
	} else {
	  root.BackToTop = factory(root);
	}
})(typeof global !== 'undefined' ? global : this.window || this.global, function (root) {

	'use strict';

	var _hasInitialized = false;
	var _publicMethods = {};
	var _settings = {
		buttonSelector: '#back-to-top',
		showClass: 'back-to-top--show'

	};
	var _buttonElement;
	var _lastScrollPosition = 0;



	/*!
	* Merge two or more objects together.
	* (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
	* @param   {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
	* @param   {Object}   objects  The objects to merge together
	* @returns {Object}            Merged values of defaults and options
	*/
	var extend = function () {
		// Variables
		var extended = {};
		var deep = false;
		var i = 0;

		// Check if a deep merge
		if ( Object.prototype.toString.call( arguments[0] ) === '[object Boolean]' ) {
			deep = arguments[0];
			i++;
		}

		// Merge the object into the extended object
		var merge = function (obj) {
			for (var prop in obj) {
				if (obj.hasOwnProperty(prop)) {
					// If property is an object, merge properties
					if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
						extended[prop] = extend(extended[prop], obj[prop]);
					} else {
						extended[prop] = obj[prop];
					}
				}
			}
		};

		// Loop through each object and conduct a merge
		for (; i < arguments.length; i++) {
			var obj = arguments[i];
			merge(obj);
		}

		return extended;
	};



	/**
	 * Handle document clicks and route to the appropriate function.
	 */
	 function handleScroll() {
		var currentScrollPosition = window.pageYOffset || document.body.scrollTop;
		var winHeight = window.innerHeight;
		var scrollPercent = currentScrollPosition / winHeight;
		var scrollPercentRounded = Math.round( scrollPercent * 100 );

		if ( scrollPercentRounded > 150 ) {
			_buttonElement.classList.add( _settings.showClass );
		}
		else{
			_buttonElement.classList.remove( _settings.showClass );
		}
	};



	/**
	 * Handle document clicks and route to the appropriate function.
	 */
	 function handleCapturedClick( e ) {
		if ( e.target.closest( _settings.buttonSelector ) ) {
			e.preventDefault();

			window.scrollTo( {
				top: 0,
				behavior: 'smooth'
			} );

			// Remove show state
			_buttonElement.classList.remove( _settings.showClass );
			_buttonElement.blur();
		}
	};

	

	/**
	 * Initialize
	 */
	_publicMethods.init = function( options ) {
		if ( _hasInitialized ) return;

		_buttonElement = document.querySelector( _settings.buttonSelector );
		
		// Bail if back to top button not found
		if ( ! _buttonElement ) { return; }

		// Merge with general settings with options
		_settings = extend( _settings, options );

		// Set event handlers
		document.addEventListener( 'click', handleCapturedClick );
		window.addEventListener( 'scroll', throttle( handleScroll, 100 ) );

		_hasInitialized = true;
	};



	//
	// Public APIs
	//
	return _publicMethods;

});
